import { useEffect, useState } from "react";
import "@/App.css";
import { COPY } from "@/data/b2bContent";
import { B2B_IMAGES } from "@/data/b2bContent";
import { SiteHeader } from "@/components/SiteHeader";
import { HeroSection } from "@/components/HeroSection";
import { Marquee } from "@/components/Marquee";
import { ServicesSection } from "@/components/ServicesSection";
import { PropertyPassportPromo } from "@/components/PropertyPassportPromo";
import { ProfessionalsSection } from "@/components/ProfessionalsSection";
import { PartnershipSection } from "@/components/PartnershipSection";
import { PrioritySection } from "@/components/PrioritySection";
import { ProcessSection } from "@/components/ProcessSection";
import { QuoteForm } from "@/components/QuoteForm";
import { ContactSection } from "@/components/ContactSection";
import { FinalCta } from "@/components/FinalCta";
import { SiteFooter } from "@/components/SiteFooter";
import { AuthCallback } from "@/components/AuthCallback";
import { AdminDashboard } from "@/components/AdminDashboard";
import { DossierPage } from "@/components/DossierPage";

function useRevealObserver(language) {
    useEffect(() => {
        const elements = Array.from(document.querySelectorAll(".reveal"));
        if (!("IntersectionObserver" in window)) {
            elements.forEach((element) => element.classList.add("is-visible"));
            return undefined;
        }
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("is-visible");
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.14 });
        elements.forEach((element) => observer.observe(element));
        return () => observer.disconnect();
    }, [language]);
}

function LandingPage() {
    const [language, setLanguage] = useState("fr");
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const t = COPY[language];

    useRevealObserver(language);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 16);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <div className={`site ${scrolled ? "site--scrolled" : ""}`} data-testid="reset365-site">
            <SiteHeader t={t} lang={language} setLang={setLanguage} menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
            <main data-testid="reset365-main-content">
                <HeroSection t={t} image={B2B_IMAGES.hero} />
                <Marquee items={t.marquee} />
                <ServicesSection t={t.services} lang={language} images={B2B_IMAGES.services} />
                <PropertyPassportPromo t={t.passport} lang={language} />
                <ProfessionalsSection t={t.professionals} />
                <PartnershipSection t={t.partnership} />
                <PrioritySection t={t.priority} />
                <ProcessSection t={t.process} />
                <QuoteForm t={t.quote} lang={language} />
                <ContactSection t={t.contact} lang={language} />
                <FinalCta t={t.final} />
            </main>
            <SiteFooter t={t.footer} nav={t.nav} lang={language} />
        </div>
    );
}

function App() {
    const pathname = window.location.pathname;
    if (window.location.hash.includes("session_id=")) return <AuthCallback />;
    if (pathname.startsWith("/admin/dossiers")) return <AdminDashboard />;
    if (pathname.startsWith("/dossier/")) return <DossierPage code={pathname.split("/")[2] || ""} />;
    return <LandingPage />;
}

export default App;
